<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('contract') }}</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="6" class="d-flex">
                    <div style="max-width: 250px" class="mr-2">
                        <v-text-field
                            :value="contractName"
                            disabled
                            class="py-0 my-n2"
                        ></v-text-field>
                    </div>
                    <v-btn
                        icon
                        :href="`/download/contract/buyer?contractID=${contractId}&orderID=${orderData.id}`"
                        small
                    >
                        <v-icon small class="text--main-yellow">
                            save_alt
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" md="6" v-if="orderData.contractHistory && orderData.contractHistory.length" class="text-left text-md-right">
                    <contract-history :history="orderData.contractHistory" history-type="buyer" :order-id="orderData.id"></contract-history>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import OrderExtendInfo from "../../../mixins/OrderExtendInfo"
import ContractHistory from "../../../components/contract-history"
import ContractsService from '../../../../app-front/services/api/ContractsService';

export default {
    name: "ExtendContractInfo",
    mixins: [
        OrderExtendInfo
    ],
    components: {ContractHistory},
    data() {
        return {
            initialContractID: null,
        }
    },
    computed: {
        contractName() {
            return this.orderData.contractFile ? this.orderData.contractFile.title : '';
        },
        contractId() {
            return this.orderData.contractFile ? this.orderData.contractFile.id : '';
        },
    },
    methods: {
        attach() {
            const params = {
                contractId:  this.orderData.contractFile ? this.orderData.contractFile.id : null,
                orderId: this.orderData.id,
            };

            ContractsService.attachToOrder(params)
                .then(res => {
                    if(!res.data) return false;

                    this.responseHandle(res.data);
                })
                .catch(err => {
                    console.log(err);
                })
        },
        responseHandle(data) {
            this.snackText = data.msg;
            this.snackOpen = true;
            this.orderData.contractFile = data.contract;
            this.initialContractID = this.orderData.contractFile ? this.orderData.contractFile : null;
            this.valueChange('contractFile');
        }
    },
    watch: {
        order() {
            this.initialContractID = this.orderData.contractFile ? this.orderData.contractFile : null;
        }
    },
}
</script>
